import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelDvp: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'X',
  },
  {
    code: 6,
    label: 'J',
  },
  {
    code: 7,
    label: 'E',
  },
  {
    code: 8,
    label: '.',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 9,
    label: 'U',
  },
  {
    code: 10,
    label: 'I',
  },
  {
    code: 11,
    label: 'D',
  },
  {
    code: 12,
    label: 'C',
  },
  {
    code: 13,
    label: 'H',
  },
  {
    code: 14,
    label: 'T',
  },
  {
    code: 15,
    label: 'N',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'B',
  },
  {
    code: 18,
    label: 'R',
  },
  {
    code: 19,
    label: 'L',
  },
  {
    code: 20,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 21,
    label: 'P',
  },
  {
    code: 22,
    label: 'O',
  },
  {
    code: 23,
    label: 'Y',
  },
  {
    code: 24,
    label: 'G',
  },
  {
    code: 25,
    label: 'K',
  },
  {
    code: 26,
    label: ',',
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 27,
    label: 'Q',
  },
  {
    code: 28,
    label: 'F',
  },
  {
    code: 29,
    label: "'",
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 30,
    label: '&',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '[',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 32,
    label: '{',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 33,
    label: '}',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '(',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '=',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 36,
    label: '*',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: ')',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 38,
    label: '+',
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: ']',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: '!',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 46,
    label: '#',
    meta: [
      {
        label: '`',
        modifiers: MOD.SFT,
      },
      {
        label: '`',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 47,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 48,
    label: '@',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 49,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'S',
  },
  {
    code: 52,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 53,
    label: '$',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: 'W',
  },
  {
    code: 55,
    label: 'V',
  },
  {
    code: 56,
    label: 'Z',
  },
  {
    code: 520,
    label: '>',
  },
  {
    code: 532,
    label: ':',
  },
  {
    code: 538,
    label: '<',
  },
  {
    code: 541,
    label: '"',
  },
  {
    code: 542,
    label: '%',
  },
  {
    code: 543,
    label: '7',
  },
  {
    code: 544,
    label: '5',
  },
  {
    code: 545,
    label: '3',
  },
  {
    code: 546,
    label: '1',
  },
  {
    code: 547,
    label: '9',
  },
  {
    code: 548,
    label: '0',
  },
  {
    code: 549,
    label: '2',
  },
  {
    code: 550,
    label: '4',
  },
  {
    code: 551,
    label: '6',
  },
  {
    code: 557,
    label: '8',
  },
  {
    code: 558,
    label: '`',
  },
  {
    code: 559,
    label: '?',
  },
  {
    code: 560,
    label: '^',
  },
  {
    code: 561,
    label: '|',
  },
  {
    code: 564,
    label: '_',
  },
  {
    code: 565,
    label: '~',
  },
  {
    code: 4616,
    label: '>',
  },
  {
    code: 4628,
    label: ':',
  },
  {
    code: 4634,
    label: '<',
  },
  {
    code: 4637,
    label: '"',
  },
  {
    code: 4638,
    label: '%',
  },
  {
    code: 4639,
    label: '7',
  },
  {
    code: 4640,
    label: '5',
  },
  {
    code: 4641,
    label: '3',
  },
  {
    code: 4642,
    label: '1',
  },
  {
    code: 4643,
    label: '9',
  },
  {
    code: 4644,
    label: '0',
  },
  {
    code: 4645,
    label: '2',
  },
  {
    code: 4646,
    label: '4',
  },
  {
    code: 4647,
    label: '6',
  },
  {
    code: 4653,
    label: '8',
  },
  {
    code: 4654,
    label: '`',
  },
  {
    code: 4655,
    label: '?',
  },
  {
    code: 4656,
    label: '^',
  },
  {
    code: 4657,
    label: '|',
  },
  {
    code: 4660,
    label: '_',
  },
  {
    code: 4661,
    label: '~',
  },
];
